import { type FC } from 'react';
import {
  UsersFour
} from '@phosphor-icons/react';
import { UiIcon, type UiIconProps } from './UiIcon';

export type UiIconUsersFourProps = Omit<UiIconProps, 'IconComponent'>;

export const UiIconUsersFour: FC<UiIconUsersFourProps> = (props) => {
  return (
    <UiIcon
      IconComponent={UsersFour}
      {...props}
    />
  );
};
